<template>
  <div class="board-content-td activeCardHover" :class="dateReminder()" @click="handleClick">
    <div class="board-top">
      <div class="task-title-wrap">
        <div class="task-title-wrap-item">
          <div @click.stop class="task-check">
            <el-checkbox  :disabled="true"></el-checkbox>
          </div>
          <toolTip style="width: 100%" :title="dataset.task_name">
            <span class="task-title" :title="dataset.task_name">{{ dataset.task_name }}</span>
          </toolTip>
        </div>
      </div>
      <div class="task-create-date">
        <div class="task-flex-box">
          <div class="task-left">
            <div class="task-left-item" v-if="children && children.length > 0">
              <i class="icon iconfont iconicon_subtasks2"></i>
              <div class="task-sub-info">
                <span class="finish_num">0</span>
                <span class="slash">/</span>
                <span class="total_num">{{ lost99(children.length) }}</span>
              </div>
            </div>
            <div class="task-left-item" v-if="dataset.association_dependency && dataset.association_dependency.post_tasks && dataset.association_dependency.pre_tasks && dataset.association_dependency.post_tasks.length + dataset.association_dependency.pre_tasks.length > 0">
              <i class="icon iconfont iconicon_associated_tasks"></i>
              <span>{{ lost99(dataset.association_dependency.post_tasks.length + dataset.association_dependency.pre_tasks.length ) }}</span>
            </div>
            <div class="task-left-item" v-if="getFileCount > 0">
              <i class="icon iconfont iconicon_annex2"></i>
              <span>{{ lost99(getFileCount) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board-bottom">
      <div class="task-principal">
       <div class="avatar-wrap">
          <span v-if="dataset.end_time" class="task-date">{{ dataset.end_time.replace(/-/g, "/") }}</span>
          <TaskLevel :level="dataset.sort_rule_name"></TaskLevel>
        </div>
        <div class="task-sn">
          <div class="task-sn-nore" @click="stopde" :class="{'visibleActive': show}">
            <el-dropdown @command="handleCommand" v-model="show" size="small" trigger="click"  @visible-change="changeListShow">
              <span class="task-sn-hover">
                <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="task-drop-item border" :command="{ type: 'del', dataset }" ><i class="icon iconfont iconicon_recycle_bin"></i>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateReminder } from "@/utils";
import TaskLevel from '@/components/taskLevel'
import api from "@/services/api/task/task";
export default {
  props: {
    dataset: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: null
    }
  },
  components: {
    TaskLevel
  },
  computed: {
    children() {
      return this.dataset.children
    },
    getFileCount() {
      return this.dataset.standard_components_values.reduce((pre, item) => {
        if (item.component_code === "TaskComponent.Attachment.Attachment") {
          return pre + item?.component_value?.length
        } else {
          return pre
        }
      }, 0)
    }
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    console.log('---------', this.dataset, this.dataset.children)
  },
  methods: {
    lost99(num) {
      return num * 1 > 99 ? "99+" : Number(num);
    },
    stopde(e) {
      e.stopPropagation();
    },
    handleCommand(comm) {
      this.$emit('handleCommand', comm)
    },
    changeListShow() {
      this.show = !this.show
    },
    dateReminder() {
      let result = dateReminder(this.dataset)
      if (result === 'complete') {
        return 'children-row complete-time complete-task'
      }else if (!this.dataset.end_time) {
        return "complete-time"
      } else if (result === "expired") {
        return "children-row complete-time expired"
      } else if (result === "remind") {
        return "children-row complete-time remind"
      } else {
        return "children-row complete-time"
      }
    },
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss">
  .board-content-td {
    .mask-check {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      border-radius: 4px;
      border: 1px solid transparent;
    }
    .check {
      border: 1px solid #2682FF;
      background: rgba(38,130,255,0.08);
    }
  }
</style>
